<template>
  <div style="height: 100vh; position: relative; overflow: hidden;" class="d-flex flex-column align-content-between">
    <div class="nav navbar py-4 font-24 font-weight-bold bg-custom d-flex justify-content-center">
      <div class="w-50 text-center header">
        <span class="text-white">登録が完了しました！</span>
      </div>
    </div>
    <div class="d-flex justify-content-center body-content">
      <div class="w-50 d-flex align-items-center flex-column">
        <div class="mt-5 mb-5">
          <img src="../assets/images/confirm.svg" alt="thankyou image" class="img-fluid">
        </div>
        <button class="btn btn-cstm btn-cstm-primary mt-2 h-auto py-2" @click="afterVerify">Login</button>
      </div>
    </div>
 </div>
</template>

<script>
import Api from '@/config/api';
import swal from 'sweetalert';

export default {
  data() {
    return {
      token: this.$route.params.token,
      id: this.$route.params.id,
    };
  },
  methods: {
    async verify() {
      try {
        if (!this.token || !this.id) {
          this.$router.push({ name: 'pageNotFound' });
        } else {
          const result = await this.axios({
            method: 'post',
            data: {
              token: this.token,
              _id: this.id,
            },
            url: Api.url(Api.endpoints.verifyNewEmail),
          });
        }
      } catch (error) {
        if (error.response.status === 400) {
          await swal({
            text: 'このリンクは期限切れか無効になっています。',
            icon: 'warning',
            buttons: {
              ok: 'はい',
            },
          });
          this.$router.push({ name: 'login' });
        }
      }
    },
    afterVerify() {
      this.$router.push({ name: 'login' });
    },
  },
  async created() {
    await this.verify();
  },
};
</script>

<style scoped>
.bg-custom{
  background-color: #076d6c;
}

.font-24{
  font-size: 24px;
}

.font-18{
  font-size: 18px;
}


.btn-cstm {
  padding: 15px 20px;
  width: 343px;
  border-radius: 8px;
  height: 55px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff!important;
}


.overlay{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

@media only screen and (max-width: 992px) {
  .navbar>div, .body-content>div{
    width: 75% !important;
  }
}

@media only screen and (max-width: 576px) {
  .navbar>div, .body-content>div{
    width: 100% !important;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
@media (max-width:550px){
  .text-white{
    font-size:20px;
  }
}

.confirm-logo{
  max-height:50px;
}

.background-color{
  background: rgba(0,0,0,.4);
}

@media (max-width: 767px) {
  .left_align {
    text-align: left !important;
  }
  .line__break {
    display: none;
  }
}

.font-18{
  font-size: 18px !important;
}

.font-bold{
  font-weight: bold;
}

@media (max-width: 577px) {
  .stickyFooter > div {
    flex-direction: column-reverse !important;
    align-items: center;
  }

  .stickyFooter > div > button:nth-child(1), >>> .custom-modal-footer-mobile > button:nth-child(1){
    margin-bottom: .5rem !important;
  }
}

.w-230{
  width: 230px;
}

</style>
